(function($){
    var $expert = {
        expertMobileNave: function($){
            var $nav = $('#navButton');
            $nav.on('click',function(e){
                e.preventDefault();
                var $parent = $(this).parent();
                $($parent).toggleClass('is_active');
            });
        },
        main: function($){
            this.expertMobileNave($);
            this.toggle($);
        },
        toggle: function ($) {
            $('.plus-icon').click(function(){
                if ($(this).parent('.plus').hasClass('close')) {
                    $(this).parent('.plus').find('+ div').slideDown();
                    $(this).text('-');
                } else {
                    $(this).text('+');
                    $(this).parent('.plus').find('+ div').slideUp();
                }
                $(this).parent('.plus').toggleClass('close');
            });
        }
    };
    $expert.main($);
}(jQuery));